// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chat-off","clipPath":"url(#clip0_543_1240)"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M9.65446 3.001H8.65446L8.65346 3L9.65446 3.001ZM9.65446 3.001L21.5 3.00001L21.5 14.582M21.5 14.582V15.582L21.501 15.583L21.5 14.582ZM17 17.001H6.5L2.5 20.501L2.5 3.00098H3L17 17.001Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M22 22.001L2 2.00098","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chat-off')
export default class ChatOffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-off',
    }
  }
}
